import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryCountriesMapData = Offers.Components['CountryMap']['entries'];

interface UseQueryCountriesMapOptions {
  initialData?: UseQueryCountriesMapData;
}

interface UseQueryCountriesMapParameters {
  countryId: number | null;
}

const useQueryCountriesMap = (
  parameters: UseQueryCountriesMapParameters,
  options?: UseQueryCountriesMapOptions,
) => {
  const locale = getLocale();

  const query = useQuery<UseQueryCountriesMapData>(
    [QueryId.COUNTRIES_MAP, parameters, locale],
    async () => {
      const fetchResponse = await fetch(
        `/api/countries/map?countryId=${parameters.countryId}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .then(response => response.result.entries)
        .catch(error => {
          console.error('hooks.useQueryCountriesMap', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters.countryId,
      initialData: options?.initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryCountriesMap;
